import { utility } from '@phi/components';
import styles from './FormToggle.module.scss';
import { defineComponent, h } from 'vue';

export default defineComponent({
    props: {
        value: {
            required: true,
            type: Boolean,
        },
    },

    emits: {
        'update:value': (x: boolean) => true,
    },

    methods: {
        on_click() {
            this.$emit('update:value', !this.value);
        },
    },

    render() {
        return h('div', {
            'data-checked': this.value,
            class: {
                [styles.checkbox]: true,
                [styles.checked]: this.value,
                [utility.pointer]: true,
            },
            onClick: this.on_click,
        });
    },
});
